module.exports = __webpack_public_path__ + "img/4.aac36667.jpg";